<div class="main-container">
  <div class="container">
    <h3 class="title">
      <!-- Upload Primary ID -->
      {{ "advanced-pages.upload-id.upload-primary-id" | i18next }}
      <span class="tw-text-[#9FE9FE]">*</span>
    </h3>
    <span class="note">
      {{ "advanced-pages.upload-id.uploadid-note" | i18next }}
    </span>
    <ol
      class="tw-text-[14px] tw-text-white tw-list-decimal tw-pl-6 tw-font-normal tw-mb-[12px]"
    >
      <li>{{ "advanced-pages.upload-id.uploadid-guide-1" | i18next }}</li>
      <li>{{ "advanced-pages.upload-id.uploadid-guide-2" | i18next }}</li>
    </ol>

    <app-document-upload
      [labelText]="'advanced-pages.upload-id.idtype-input' | i18next"
      [shouldUseNativePicker]="true"
      [sampleImages]="idType().sample"
      [form]="primaryIdForm"
      [id]="'primary-id'"
      [nationality]="nationality"
    />
  </div>
  @if (uploadError) {
  <div>
    <p class="error-message">{{ uploadError }}</p>
  </div>
  }

</div>
<app-cta-buttons
currentPage="poi"
[pageNames]="advancedPages"
tier="advanced"
[disabled]="nextDisabled"
(nextEvent)="onNextPressed()"
[nextCallback]="onNextPressed"
[isLoading]="isLoading"
/>